import { styled } from 'baseui'

export const StatusText = styled<'span', { $warning: boolean }>('span', ({ $theme, $warning }) => ({
  fontSize: '13px',
  lineHeight: '18px',
  whiteSpace: 'nowrap',
  color: $warning ? $theme.colors.dangerPulseText : $theme.colors.textPulseMuted,
  fontWeight: $warning ? 600 : 400,
}))
